import React from "react";

function Textarea({
  id = "",
  name = "",
  type = "",
  className = "",
  value = "",
  disabled = false,
  onChange,
  minLength,
  maxLength,
  checked = false,
  placeHolder = "",
  multiple = false,
  accept,
  rows,
}) {
  const handleOnChange = (e) => {
    if (onChange) onChange(e);
  };

  return (
    <textarea
      id={id}
      name={name}
      type={type}
      className={className || "form-control"}
      value={value}
      onChange={handleOnChange}
      minLength={minLength}
      maxLength={maxLength}
      disabled={disabled}
      checked={checked}
      placeholder={placeHolder}
      multiple={multiple}
      accept={accept}
      rows={rows || ''}
    />
  );
}

export default Textarea;
